"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _roleModel = _interopRequireDefault(require("./components/roleModel"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    roleModel: _roleModel.default
  },
  data: function data() {
    var _this = this;
    var validateRoleName = function validateRoleName(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('role.error.roleName')));
      } else if (_this.errorKeys.indexOf('roleName') >= 0) {
        callback(new Error(_this.errorInfo['roleName']));
        _this.resetError('roleName');
      } else {
        callback();
      }
    };
    var validateRoleCode = function validateRoleCode(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('role.error.roleCode')));
      } else if (_this.errorKeys.indexOf('roleCode') >= 0) {
        callback(new Error(_this.errorInfo['roleCode']));
        _this.resetError('roleCode');
      } else {
        callback();
      }
    };
    return {
      pageName: 'role',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        roleName: '',
        roleCode: ''
      },
      dialogStatus: 'create',
      form: {
        rolePk: '',
        roleName: '',
        roleCode: '',
        remark: ''
      },
      initForm: {
        rolePk: '',
        roleName: '',
        roleCode: '',
        remark: ''
      },
      rules: {
        roleName: [{
          required: true,
          trigger: ['change'],
          validator: validateRoleName
        }],
        roleCode: [{
          required: true,
          trigger: ['change'],
          validator: validateRoleCode
        }]
      },
      errorKeys: [],
      errorInfo: {},
      isShowRoleAuthModel: false,
      authData: [],
      functionsCheckList: [],
      initFunctionsCheckList: [],
      menusCheckList: [],
      initMenusCheckList: []
    };
  },
  computed: {
    stateBtn: function stateBtn() {
      return function (state) {
        if (state.toLowerCase() === 'enable') {
          state = 'disabled';
        } else {
          state = 'enable';
        }
        return this.$t("common.".concat(state));
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          roleName: this.searchVal.roleName,
          roleCode: this.searchVal.roleCode
        }
      };
      this.listLoading = true;
      this.$api.role.getList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    resetData: function resetData() {
      this.searchVal = {};
      this.searchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    create: function create() {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.form = {
        rolePk: '',
        roleName: '',
        roleCode: '',
        remark: ''
      };
      this.initForm = {
        rolePk: '',
        roleName: '',
        roleCode: '',
        remark: ''
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.rolePk;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.isLoading = true;
        _this5.$api.role.getDetail(_this5.currentId).then(function (res) {
          _this5.isLoading = false;
          var _res$data = res.data,
            rolePk = _res$data.rolePk,
            roleName = _res$data.roleName,
            roleCode = _res$data.roleCode,
            remark = _res$data.remark;
          _this5.form = {
            rolePk: rolePk,
            roleName: roleName,
            roleCode: roleCode,
            remark: remark
          };
          _this5.initForm = {
            rolePk: rolePk,
            roleName: roleName,
            roleCode: roleCode,
            remark: remark
          };
          resolve(_this5.form);
        }).catch(function () {
          _this5.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    switchState: function switchState(row, index) {
      var _this6 = this;
      if (row.state.toLowerCase() === 'enable') {
        this.$confirm(this.$t('common.confirm5'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this6.isLoading = true;
          _this6.$api.role.disabledItem(row.rolePk).then(function (res) {
            _this6.$message.success(_this6.$t('common.disableSuccess'));
            _this6.$set(_this6.list[index], 'state', 'DISABLED');
            _this6.isLoading = false;
          }).catch(function () {
            // this.$message.error('删除失败')
            _this6.isLoading = false;
          });
        }).catch(function () {});
      } else {
        this.$confirm(this.$t('common.confirm6'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this6.isLoading = true;
          _this6.$api.role.enableItem(row.rolePk).then(function (res) {
            _this6.$message.success(_this6.$t('common.enableSuccess'));
            _this6.$set(_this6.list[index], 'state', 'ENABLE');
            _this6.isLoading = false;
          }).catch(function () {
            // this.$message.error('删除失败')
            _this6.isLoading = false;
          });
        }).catch(function () {});
      }
    },
    deleteItem: function deleteItem(row) {
      var _this7 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this7.isLoading = true;
        _this7.$api.role.deleteItem([row.rolePk]).then(function (res) {
          _this7.$message.success(_this7.$t('common.deleteSuccess'));
          _this7.isLoading = false;
          _this7.refreshData();
        }).catch(function () {
          _this7.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this8 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this8.isLoading = true;
        _this8.$api.role.saveItem(_this8.form).then(function (res) {
          _this8.$message.success(_this8.$t('common.saveSuccess'));
          _this8.isLoading = false;
          _this8.isShowModel = false;
          _this8.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this8.resetError();
            err.errorInfos.forEach(function (item) {
              _this8.errorKeys.push(item.key);
              _this8.errorInfo[item.key] = item.errMsg;
            });
            _this8.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this8.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    },
    roleAuth: function roleAuth(row) {
      var _this9 = this;
      this.dialogStatus = 'distributeAuth';
      this.currentId = row.rolePk;
      if (this.currentId === null) {
        return;
      }
      this.getAuthDetail().then(function (res) {
        _this9.isShowRoleAuthModel = true;
      });
    },
    checkAuthDetail: function checkAuthDetail(row) {
      var _this0 = this;
      this.dialogStatus = 'checkAuthDetail';
      this.currentId = row.rolePk;
      if (this.currentId === null) {
        return;
      }
      this.getAuthDetail().then(function (res) {
        _this0.isShowRoleAuthModel = true;
      });
    },
    getAuthDetail: function getAuthDetail() {
      var _this1 = this;
      return new Promise(function (resolve) {
        _this1.isLoading = true;
        _this1.$api.role.rolePermissionDetail(_this1.currentId).then(function (res) {
          var permissions = res.data.permissions || [];
          var functions = res.data.functions || [];
          var menus = res.data.menus || [];
          _this1.isLoading = false;
          _this1.authData = (0, _toConsumableArray2.default)(permissions);
          _this1.functionsCheckList = (0, _toConsumableArray2.default)(functions);
          _this1.initFunctionsCheckList = (0, _toConsumableArray2.default)(functions);
          _this1.menusCheckList = (0, _toConsumableArray2.default)(menus);
          _this1.initMenusCheckList = (0, _toConsumableArray2.default)(menus);
          resolve(_this1.authData);
        }).catch(function () {
          _this1.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    handleCheckedAuthChange: function handleCheckedAuthChange(value) {
      // 点击功能checkbox
      var menusIndex = this.menusCheckList.indexOf(value.menuPk);
      var functionsIndex = this.functionsCheckList.indexOf(value.functionPk);
      if (functionsIndex !== -1 && menusIndex === -1) {
        this.menusCheckList.push(value.menuPk);
      }
    },
    handleMenuCancel: function handleMenuCancel(value) {
      var _this10 = this;
      if (value.children && value.children.length) {
        // 点击父级菜单
        value.children && value.children.forEach(function (menu) {
          _this10.handleMenuCancel(menu);
          var subMenusIndex = _this10.menusCheckList.indexOf(menu.menuPk);
          if (subMenusIndex !== -1) {
            _this10.menusCheckList.splice(subMenusIndex, 1);
          }
          menu.functionList && menu.functionList.forEach(function (func) {
            var functionsIndex = _this10.functionsCheckList.indexOf(func.functionPk);
            if (functionsIndex !== -1) {
              _this10.functionsCheckList.splice(functionsIndex, 1);
            }
          });
        });
      }
      if (value.functionList && value.functionList.length) {
        value.functionList && value.functionList.forEach(function (item, index) {
          var functionsIndex = _this10.functionsCheckList.indexOf(item.functionPk);
          if (functionsIndex !== -1) {
            _this10.functionsCheckList.splice(functionsIndex, 1);
          }
        });
      }
    },
    handleMenuCheck: function handleMenuCheck(value) {
      var _this11 = this;
      if (value.children && value.children.length) {
        // 点击父级菜单
        value.children && value.children.forEach(function (menu) {
          _this11.handleMenuCheck(menu);
          var subMenusIndex = _this11.menusCheckList.indexOf(menu.menuPk);
          if (subMenusIndex === -1) {
            _this11.menusCheckList.push(menu.menuPk);
          }
          menu.functionList && menu.functionList.forEach(function (func) {
            var functionsIndex = _this11.functionsCheckList.indexOf(func.functionPk);
            if (functionsIndex === -1) {
              _this11.functionsCheckList.push(func.functionPk);
            }
          });
        });
      }
      if (value.functionList && value.functionList.length) {
        value.functionList && value.functionList.forEach(function (item, index) {
          var functionsIndex = _this11.functionsCheckList.indexOf(item.functionPk);
          if (functionsIndex === -1) {
            _this11.functionsCheckList.push(item.functionPk);
          }
        });
      }
      if (value.parentMenuPk) {
        // 点击的菜单有父菜单
        var subMenusIndex = this.menusCheckList.indexOf(value.parentMenuPk);
        if (subMenusIndex === -1) {
          this.menusCheckList.push(value.parentMenuPk);
        }
      }
    },
    handleCheckedAuthChange2: function handleCheckedAuthChange2(value) {
      // 点击菜单checkbox
      console.log(value);
      var menusIndex = this.menusCheckList.indexOf(value.menuPk);
      if (menusIndex === -1) {
        // 点击后取消选中
        this.handleMenuCancel(value);
      } else {
        // 点击后选中
        this.handleMenuCheck(value);
      }
    },
    saveRoleAuthItem: function saveRoleAuthItem() {
      var _this12 = this;
      this.isLoading = true;
      this.$api.role.rolePermissionSave({
        rolePk: this.currentId,
        menuPks: this.menusCheckList,
        functionPks: this.functionsCheckList
      }).then(function (res) {
        _this12.$message.success(_this12.$t('common.authSuccess'));
        _this12.isLoading = false;
        _this12.isShowRoleAuthModel = false;
      }).catch(function () {
        _this12.isLoading = false;
        // this.$message.error('保存失败')
      });
    }
  }
};